import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../../globals';
import { DeliberyNoteServices } from '../../../../delibery_note/services';
import { TranslateService } from '@ngx-translate/core';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
/**
 * Generated class for the ProductPartialFoodcostIngSelectedPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-expenses-deno-partial-deno-selected',
  templateUrl: 'expenses-deno-partial-deno-selected.html',
})
export class ExpensesDenoPartialDenoSelectedPage {
  //datatable
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public deliberyNoteServices: DeliberyNoteServices,
    public translate: TranslateService,) {

  }

  delete(element) {
    var index = this.deliberyNoteServices.delibery_notes_array_tmp.findIndex(x => x[0] == element[0]);
    if (index >= 0) {
      this.deliberyNoteServices.delibery_notes_array_tmp.splice(index, 1);
      this.deliberyNoteServices.delibery_notes_array_tmp = [...this.deliberyNoteServices.delibery_notes_array_tmp];
    }
  }

  clickElement(event) {
    if (event.type == 'click') {
      this.delete(event.row);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/income-expenses/expenses-deno-create/expenses-deno-create-select-deno/expenses-deno-partial-deno-selected/expenses-deno-partial-deno-selected.ts